import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  Row,
  Col,
  Button,
  Space,
  Image,
  Typography,
  Modal,
  message,
} from "antd";
import SiteReportAction from "~/components/site/SiteReportAction";
import EleSpender from "~/components/app/EleSpender";

import { getGroupApply, createGroupApply } from "~/services/groups";

const { Text, Link } = Typography;

const GroupJoinInfo = ({ applyInfo }) => {
  if (applyInfo.join_type === "link") {
    return (
      <Link
        legacyBehavior
        href={applyInfo.join_url}
        target="_blank"
        className="text-primary text-break"
        copyable>
        {applyInfo.join_url}
      </Link>
    );
  }
  
  if (applyInfo.join_type === "qrcode") {
    return <Image src={applyInfo.join_url} width={136} preview={false} />;
  }
};

/**
 * 群组入群方式组件，用于显示群组的入群方式和入群按钮
 *
 * @param {object} group 群组信息
 */
const GroupJoin = ({ group }) => {
  const { token } = useSelector((state) => state.user);
  const [applyInfo, setApplyInfo] = useState({ applied: false });

  const handleJoin = () => {
    Modal.confirm({
      title: "确认要申请入群吗？",
      content: (
        <p>
          申请入群将消耗 <span className="text-primary">{group.ele}</span> 电量
        </p>
      ),
      onOk: () => {
        createGroupApply(token, group.id).then(applyInfo => {
          setApplyInfo(applyInfo);
          message.success("申请成功");
        }).catch(error => message.error(error.message));
      },
    });
  };

  const handleInit = () => {
    token && getGroupApply(token, group.id).then(setApplyInfo);
  };

  useEffect(handleInit, [group]);

  return (
    <Space direction="vertical" style={{ display: "flex" }}>
      <Row justify="space-between" align="middle">
        <Col>
          <Text>入群方式</Text>
        </Col>
        <Col>
          <SiteReportAction contentType={"Group"} contentId={group.id} />
        </Col>
      </Row>

      <Row justify="center" align="middle">
        {applyInfo.applied ? (
          <GroupJoinInfo applyInfo={applyInfo} />
        ) : (
          <EleSpender ele={group.ele} onAvailable={handleJoin}>
            <Button type="primary">申请入群 ({group.ele} 电量)</Button>
          </EleSpender>
        )}
      </Row>

      {!applyInfo.applied && (
        <Row justify="center" align="middle">
          <Text type="secondary">支付电量之后显示</Text>
        </Row>
      )}
    </Space>
  );
};

export default GroupJoin;
